//----------------------------------------------------------------------------------------------------------------------
// Utilities to test for capability of the current environment
//----------------------------------------------------------------------------------------------------------------------

export function isBrowser() : boolean
{
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}

export function hasWebGPU() : boolean
{
    return isBrowser()
        && !!window.navigator.gpu;
}

//----------------------------------------------------------------------------------------------------------------------
